import Dexie, { type EntityTable } from 'dexie';

export interface CacheEntry {
    id: string;         // serialized query key
    data: string;       // AES-GCM encrypted JSON (base64url)
    iv: string;         // AES-GCM IV (base64url)
    salt: string;       // PBKDF2 salt (base64url) — one per user session
    updatedAt: number;  // Unix ms
}

export interface MetadataEntry {
    key: string;
    value: string;
}

/**
 * Global OmniChannel IndexedDB database.
 * Tables can be extended as other modules need offline caching.
 */
export class OmniChannelCacheDB extends Dexie {
    cache!: EntityTable<CacheEntry, 'id'>;
    metadata!: EntityTable<MetadataEntry, 'key'>;

    constructor() {
        super('omnichannel_cache');
        this.version(1).stores({
            cache: 'id, updatedAt',
        });
        this.version(2).stores({
            cache: 'id, updatedAt',
            metadata: 'key',
        });
    }
}

export const db = new OmniChannelCacheDB();
